"use client"

import { motion } from "framer-motion"
import { Link } from "react-router-dom"
import { ArrowRight } from "lucide-react"

export function Welcome() {
  return (
    <section id="welcome-section" className="bg-white py-12 lg:py-20">
      <div className="grid grid-cols-1 md:grid-cols-2">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="md:h-full p-6 md:p-8 lg:p-12 flex items-center justify-center"
        >
          <img
            src="https://tdjwqdpgnmzhfcqsfyjh.supabase.co/storage/v1/object/sign/images/general/Raintree-Chinese-Medicine-Renee-Knott.png?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8wYzVlMGM1NS1lYzI2LTRkMTYtOTc2MS1iZDQ1MWJhMGJiYjEiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJpbWFnZXMvZ2VuZXJhbC9SYWludHJlZS1DaGluZXNlLU1lZGljaW5lLVJlbmVlLUtub3R0LnBuZyIsImlhdCI6MTc2MjI5ODM3NSwiZXhwIjo0ODg0MzYyMzc1fQ.oWb0fbHoIsvcA0Jc2IAok36HiwggiQ3bs_1iY-jpBXU"
            alt="Raintree Chinese Medicine Renee Knott"
            className="aspect-square md:aspect-auto object-cover w-full md:w-auto md:h-full md:max-h-[600px] shadow-lg"
          />
        </motion.div>
        
        <motion.div
          initial={{ opacity: 0, x: 20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="p-6 md:p-8 lg:p-12 flex flex-col justify-center items-start"
        >
          <div className="max-w-xl">
            <h2 className="text-3xl mb-6 text-[#3f4141]">Meet Dr Renee Knott</h2>
            <p className="text-gray-600 mb-6">
              Dr Renee Knott (Chinese Med) is an AHPRA and CMRBA registered Acupuncturist and Chinese Medicine Herbalist with over 20 years of clinical experience.
            </p>
            <p className="text-gray-600 mb-6">
              She has worked in private practice for over 15 years in Melbourne and, more recently, spent four years at Bloom Chinese Medicine on the Sunshine Coast, one of Queensland's busiest fertility-focused Chinese Medicine clinics.
            </p>
            <p className="text-gray-600 mb-6">
              Whilst Renee works with a wide variety of health conditions, Renee has a particular passion for women's health and enjoys supporting women through every phase of life, from first period through to pregnancy, menopause and all the moments in between.
            </p>
            <div className="mt-6">
              <Link
                to="/dr-renee-knott"
                className="text-[#c5a574] hover:text-[#DBB981] font-medium inline-flex items-center gap-1 transition-colors text-base"
              >
                Read more about Renee
                <ArrowRight className="h-4 w-4" />
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  )
}